import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to run service locally
// envUrls.entityService = 'http://localhost:6007/entities/';

export default class EntityService {
  async getAuthorData(payload) {
    return await axiosInstance
      .get(`${envUrls.entityService}author/${payload}`)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async getDocuments(payload) {
    return await axiosInstance
      .get(`${envUrls.entityService}documents/${payload}`)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async paginatedDocuments(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}documents`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async getMetrics(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}entity/metrics`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async getEntityData(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}entity/data`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  // Call Entity Service backend to return metadata from the OpenAlex table matching the type for the ID passed in through the payload
  async getEntityMetaData(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}metadata`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  // Call Entity Service backend to return analytics from elasticsearch matching the type for the ID passed in through the payload
  async getEntityAnalytics(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}analytics`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  // Call Entity Service backend to return associations for a given entity -- used in the drilldown filter lists
  async getEntityAssociations(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}associations`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  // Call Entity Service backend to return BlueLens data for an entity -- the app currently only displays overview data so we hit the overview endpoint
  async getBlueLensData(payload) {
    return await axiosInstance
      .post(`${envUrls.entityService}bluelens/overview`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  // Call Entity Service backend to return download url for exporting advisory source
  async exportAdvisorySource(payload) {
    return await axiosInstance
      .post(
        `${envUrls.entityService}advisories/export-advisory-source`,
        payload
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }
}
